import React from 'react';

import { getColorFromStory } from '../../utils/getColorFromStory';
import { FooterBottomSection } from './FooterBottomSection/FooterBottomSection';
import { FooterCopyrightV2 } from './FooterCopyright/FooterCopyrightV2';
import { FooterHeroV2 } from './FooterHeroV2/FooterHeroV2';
import { FooterNavigationsV2 } from './FooterNavigationsV2/FooterNavigationsV2';
import { FooterContainer, FooterWrapper } from './FooterV2.style';
import { TFooterProps } from './FooterV2.types';

export const FooterV2 = ({
  description,
  localization,
  logo,
  navigations,
  socials,
  title,
  openLanguageModal,
  backgroundColor,
  ctaButton,
  divider,
  leftContent,
  rightContent,
}: TFooterProps) => {
  return (
    <FooterWrapper backgroundColor={backgroundColor ? getColorFromStory(backgroundColor) : null}>
      <FooterContainer>
        {(title || description || !!ctaButton?.length || !!divider?.length) && (
          <FooterHeroV2
            title={title}
            description={description}
            ctaButton={ctaButton}
            divider={divider}
          />
        )}

        {!!navigations?.length && <FooterNavigationsV2 navigations={navigations} />}
        {(logo?.filename || localization || !!socials.length) && (
          <FooterCopyrightV2
            logo={logo}
            localization={localization}
            socials={socials}
            openLanguageModal={openLanguageModal}
          />
        )}

        {(!!leftContent?.length || !!rightContent?.length) && (
          <FooterBottomSection leftContent={leftContent} rightContent={rightContent} />
        )}
      </FooterContainer>
    </FooterWrapper>
  );
};
